"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'You can have a Title and a custom behavior in toggle drawer icon button.';
var code = "import React from 'react';\nimport { AppBar } from 'jsc-react-ui';\n\nconst AppBarExample = () => (\n  <AppBar title=\"Page\" onToggleDrawerClick={() => alert('Clicked')} />\n);";
exports.TitleAndClickExampleAppBar = function () { return (React.createElement(common_1.Example, { title: "Title and Click", description: description, code: code },
    React.createElement(components_1.AppBar, { title: "Page", onToggleDrawerClick: function () { return alert('Clicked'); } }))); };
exports.TitleAndClickExampleAppBar.displayName = 'TitleAndClickExampleAppBar';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentAppBarPage/TitleAndClickExampleAppBar.tsx
// module id = 630
// module chunks = 0